module.exports = __webpack_public_path__ + "img/set-contact.b5480056.png";